<script>
    import { FMS_BASE } from "../../utiles/fms.util.js";
    import { processNonconformityStore, appStateStore } from "./store.js";
    import { slide, fade } from "svelte/transition";
    import * as api from "../../utiles/api.js";
    import toast from "svelte-french-toast";
    import { onMount } from "svelte";
    import { Preferences } from "@capacitor/preferences";

    let selectedDetailRow = null;
    let isRightPaneVisible = false;
    let selectedManagtAt = "N"; // 추가: 조치 여부 수동 상태 토글 변수
    let isSubDetailLoading = false; // 신규: 로딩 상태 변수
    let isSaving = false; // 신규: 저장 로딩 상태 변수
    $: isReadOnly = $processNonconformityStore.selectedItem?.is_latest === "N";

    // 불량 항목이 0건일 때 selectedManagtAt 세팅 (자동 노출 제거)
    $: {
        const details = $processNonconformityStore.details;
        const selectedItem = $processNonconformityStore.selectedItem;
        if (details && details.length === 0 && selectedItem) {
            isRightPaneVisible = false;
            selectedDetailRow = null;
            selectedManagtAt = selectedItem.has_action_saved === "Y" ? "Y" : "N";
        }
    }

    // FMS 및 미리보기 관련 상태
    let isImageZoomOpen = false;
    let zoomedImageUrl = "";
    let downloadFrame;

    let session_empno = "";
    let session_korean_nm = "";

    onMount(async () => {
        const { value } = await Preferences.get({ key: "retechInfo" });
        if (value) {
            const userData = JSON.parse(value);
            session_empno = userData.empno || userData.login_id || "ADMIN";
            session_korean_nm =
                userData.empl_nm || userData.korean_nm || "관리자";
        }
    });

    async function handleDetailRowClick(row) {
        if (
            selectedDetailRow?.inspct_sn === row.inspct_sn &&
            selectedDetailRow?.badn_sn === row.badn_sn
        ) {
            closeSidebar();
            return;
        }
        selectedDetailRow = row;
        selectedManagtAt = row.managt_at || "N"; // 추가: 현재 행의 조치 상태 바인딩
        isRightPaneVisible = true;
        await fetchSubDetails(row);
    }

    async function fetchSubDetails(row) {
        isSubDetailLoading = true;
        try {
            const params = new URLSearchParams({
                bplc_code: row.bplc_code || "01",
                prdctn_plan_no: row.prdctn_plan_no,
                odr: row.odr,
                inspct_sn: row.inspct_sn,
                badn_sn: row.badn_sn,
            });

            const response = await api.get(
                `process-nonconformity/sub-detail?${params.toString()}`,
            );

            if (response && response.data) {
                const bplc_code = row.bplc_code || "01";
                const doc_no = row.prdctn_plan_no;

                // 1. 불량 사진 FMS 정보 병합 (리텍 DB 데이터 정렬 우선)
                let defectPhotos = (response.data.defectPhotos || []).sort(
                    (a, b) => (a.photo_sn || 0) - (b.photo_sn || 0),
                );
                if (defectPhotos.length > 0) {
                    const fmsRes = await api.get(
                        FMS_BASE + "/api/v1/mngrfile",
                        {
                            params: {
                                bcnc_code: "SLG00166",
                                bplc_code,
                                menu_code: "QCM_INST_0100",
                                doc_no,
                                sn_1: row.odr,
                                sn_2: row.inspct_sn,
                                sn_3: row.badn_sn,
                                sn_4: 0,
                                target_sn_idx: 4,
                            },
                        },
                    );
                    if (fmsRes && fmsRes.data) {
                        const sortedFms = [...fmsRes.data].sort(
                            (a, b) => Number(a.sn_4 || 0) - Number(b.sn_4 || 0),
                        );

                        defectPhotos = defectPhotos.map((p, idx) => {
                            const f =
                                sortedFms.find(
                                    (fd) =>
                                        String(fd.sn_4) === String(p.photo_sn),
                                ) || sortedFms[idx];

                            return f
                                ? {
                                      ...f,
                                      ...p,
                                      url: `${FMS_BASE}/api/v1/mngrfile/display?fileNm=${f.fileNm}&filePath=${encodeURIComponent(f.filePath)}`,
                                  }
                                : p;
                        });
                    }
                }

                // 2. 조치 사진 FMS 정보 병합 (리텍 DB 데이터 정렬 우선)
                let actionPhotos = (response.data.actionPhotos || []).sort(
                    (a, b) => {
                        if (a.managt_sn !== b.managt_sn)
                            return (a.managt_sn || 0) - (b.managt_sn || 0);
                        return (a.photo_sn || 0) - (b.photo_sn || 0);
                    },
                );
                if (actionPhotos.length > 0) {
                    const fmsRes = await api.get(
                        FMS_BASE + "/api/v1/mngrfile",
                        {
                            params: {
                                bcnc_code: "SLG00166",
                                bplc_code,
                                menu_code: "ISM_PRDN_1006",
                                doc_no,
                                sn_1: row.odr,
                                sn_2: row.inspct_sn,
                                sn_3: row.badn_sn,
                                sn_4: 0,
                                sn_5: 0,
                                target_sn_idx: 3,
                            },
                        },
                    );
                    if (fmsRes && fmsRes.data) {
                        const sortedFms = [...fmsRes.data].sort((a, b) => {
                            if (a.sn_4 !== b.sn_4)
                                return (
                                    Number(a.sn_4 || 0) - Number(b.sn_4 || 0)
                                );
                            return Number(a.sn_5 || 0) - Number(b.sn_5 || 0);
                        });

                        actionPhotos = actionPhotos.map((p, idx) => {
                            const f =
                                sortedFms.find(
                                    (fd) =>
                                        String(fd.sn_4) ===
                                            String(p.managt_sn) &&
                                        String(fd.sn_5) === String(p.photo_sn),
                                ) || sortedFms[idx];

                            return f
                                ? {
                                      ...f,
                                      ...p,
                                      url: `${FMS_BASE}/api/v1/mngrfile/display?fileNm=${f.fileNm}&filePath=${encodeURIComponent(f.filePath)}`,
                                  }
                                : p;
                        });
                    }
                }

                processNonconformityStore.update((s) => ({
                    ...s,
                    defectPhotos,
                    actionDetails: response.data.actionDetails || [],
                    actionPhotos,
                }));
            }
        } catch (err) {
            console.error("Error fetching sub-detail:", err);
        } finally {
            isSubDetailLoading = false;
        }
    }

    function openFile(file, serverData) {
        if (!file && !serverData) return;
        const fileNm = file
            ? file.name
            : serverData?.fileNm ||
              serverData?.orginlFileNm ||
              serverData?.photo_nm ||
              "";
        if (!fileNm) return;
        const filePath = serverData ? serverData.filePath : "";
        const ext = fileNm.split(".").pop().toLowerCase();
        const isImage = ["jpg", "jpeg", "png", "gif", "bmp"].includes(ext);

        if (isImage) {
            const url = file
                ? URL.createObjectURL(file)
                : `${FMS_BASE}/api/v1/mngrfile/display?fileNm=${fileNm}&filePath=${encodeURIComponent(filePath)}`;
            openImageZoom(url);
        } else {
            const url = `${FMS_BASE}/api/v1/mngrfile/download?fileNm=${fileNm}&filePath=${encodeURIComponent(filePath)}&orginlFileNm=${encodeURIComponent(fileNm)}`;
            if (downloadFrame) {
                downloadFrame.src = url;
            }
        }
    }

    function openImageZoom(url) {
        zoomedImageUrl = url;
        isImageZoomOpen = true;
    }

    function closeSidebar() {
        selectedDetailRow = null;
        isRightPaneVisible = false;
    }

    function goBack() {
        appStateStore.update((s) => ({
            ...s,
            currentView: "list",
            selectedId: null,
        }));
    }

    // --- 추가/삭제/저장 로직 ---
    function addActionRow() {
        if (!selectedDetailRow)
            return toast.error("불량 항목을 먼저 선택해주세요.");
        processNonconformityStore.update((s) => ({
            ...s,
            actionDetails: [
                ...s.actionDetails,
                {
                    delchk: "N",
                    bplc_code: selectedDetailRow.bplc_code,
                    prdctn_plan_no: selectedDetailRow.prdctn_plan_no,
                    odr: selectedDetailRow.odr,
                    inspct_sn: selectedDetailRow.inspct_sn,
                    badn_sn: selectedDetailRow.badn_sn,
                    managt_sn: s.actionDetails.length + 1,
                    maner_empno: session_empno,
                    korean_nm: session_korean_nm,
                    register: session_empno,
                    managt_bgndt: new Date().toISOString().split("T")[0],
                    managt_enddt: "",
                    managt_cn: "",
                    rm: "",
                    isNew: true,
                },
            ],
        }));
    }

    function removeActionRow() {
        processNonconformityStore.update((s) => ({
            ...s,
            actionDetails: s.actionDetails.filter((a) => a.delchk !== "Y"),
        }));
    }

    // --- 서버에서 새로고침된 데이터와 선택된 행 동기화 ---
    $: {
        if (
            selectedDetailRow &&
            $processNonconformityStore.details.length > 0
        ) {
            const updatedRow = $processNonconformityStore.details.find(
                (d) =>
                    d.inspct_sn === selectedDetailRow.inspct_sn &&
                    d.badn_sn === selectedDetailRow.badn_sn,
            );
            if (
                updatedRow &&
                updatedRow.managt_at !== selectedDetailRow.managt_at
            ) {
                selectedDetailRow = {
                    ...selectedDetailRow,
                    managt_at: updatedRow.managt_at,
                };
                selectedManagtAt = updatedRow.managt_at || "N";
            }
        }
    }

    let actionCameraInput;
    let actionGalleryInput;

    function triggerActionCamera() {
        actionCameraInput.click();
    }

    function triggerActionGallery() {
        actionGalleryInput.click();
    }

    function handleActionPhotoChange(event) {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        processNonconformityStore.update((s) => {
            const newPhotos = files.map((file, idx) => ({
                delchk: "N",
                bplc_code: selectedDetailRow.bplc_code,
                prdctn_plan_no: selectedDetailRow.prdctn_plan_no,
                odr: selectedDetailRow.odr,
                inspct_sn: selectedDetailRow.inspct_sn,
                badn_sn: selectedDetailRow.badn_sn,
                managt_sn: 1, // 기본값, 실제로는 선택된 조치내역 순번 등에 맞춰야 할 수도 있음
                photo_sn: s.actionPhotos.length + idx + 1,
                photo_nm: file.name,
                file: file,
                url: URL.createObjectURL(file),
                rm: "",
                isNew: true,
            }));

            return {
                ...s,
                actionPhotos: [...s.actionPhotos, ...newPhotos],
            };
        });

        event.target.value = "";
    }

    function removeActionPhotoRow() {
        processNonconformityStore.update((s) => ({
            ...s,
            actionPhotos: s.actionPhotos.filter((p) => p.delchk !== "Y"),
        }));
    }

    async function handleSave() {
        const store = $processNonconformityStore;
        // 불량 내역이 0건일 때도 저장 버튼은 유효해야 함
        if (!selectedDetailRow && store.details.length > 0) return;

        isSaving = true;
        try {
            const bplc_code = selectedDetailRow ? (selectedDetailRow.bplc_code || "01") : (store.selectedItem.bplc_code || "01");
            const prdctn_plan_no = selectedDetailRow ? selectedDetailRow.prdctn_plan_no : store.selectedItem.prdctn_plan_no;
            const odr = selectedDetailRow ? selectedDetailRow.odr : store.selectedItem.odr;
            const inspct_sn = selectedDetailRow ? selectedDetailRow.inspct_sn : 0;
            const badn_sn = selectedDetailRow ? selectedDetailRow.badn_sn : 0;

            const payload = {
                bplc_code,
                prdctn_plan_no,
                odr,
                inspct_sn,
                badn_sn,
                managt_at: selectedManagtAt, // 수동 선택 상태 추가
                actionDetails: store.actionDetails,
                actionPhotos: store.actionPhotos.map((p) => ({
                    ...p,
                    file: undefined, // 파일 객체는 따로 처리하거나 무시
                    url: undefined,
                })),
            };

            const res = await api.postJson(
                "process-nonconformity/action/save",
                payload,
            );
            if (res && res.code === 200) {
                // 사진 파일 업로드 로직 (FMS Batch Upload - 불량 항목이 있을 때만 동작)
                if (badn_sn > 0) {
                    const allPhotos = store.actionPhotos;
                    const newPhotos = allPhotos.filter((p) => p.isNew && p.file);
                    const existingPhotos = allPhotos
                        .filter((p) => !p.isNew)
                        .map((p) => ({
                            bcnc_code: "SLG00166",
                            bplc_code: p.bplc_code || "01",
                            menu_code: "ISM_PRDN_1006",
                            doc_no: p.prdctn_plan_no,
                            sn_1: p.odr,
                            sn_2: p.inspct_sn,
                            sn_3: p.badn_sn,
                            sn_4: p.managt_sn,
                            sn_5: p.photo_sn,
                            fileNm: p.fileNm || p.photo_nm,
                            filePath: p.filePath,
                            orginlFileNm: p.orginlFileNm || p.photo_nm,
                        }));

                    // 변경사항이 있을 때만 FMS 호출 (간단히 항상 호출하여 상태 동기화)
                    const formDataFile = new FormData();
                    formDataFile.append("bcnc_code", "SLG00166");
                    formDataFile.append("bplc_code", bplc_code);
                    formDataFile.append("menu_code", "ISM_PRDN_1006");
                    formDataFile.append("doc_no", prdctn_plan_no);
                    formDataFile.append("register", session_empno);
                    formDataFile.append("updusr", session_empno);
                    formDataFile.append("sn_1", String(odr));
                    formDataFile.append("sn_2", String(inspct_sn));
                    formDataFile.append("sn_3", String(badn_sn));
                    formDataFile.append("sn_4", 0); // Batch Upload 시 sn_1~sn_3까지만 키로 쓸 것이므로 0
                    for (let i = 5; i <= 10; i++) formDataFile.append(`sn_${i}`, 0);

                    newPhotos.forEach((p) => {
                        formDataFile.append("uploadFiles", p.file);
                    });

                    formDataFile.append("target_sn_idx", 3); // sn_1, sn_2, sn_3 기준
                    formDataFile.append(
                        "reInsertListJson",
                        JSON.stringify(existingPhotos),
                    );

                    await api.post(
                        FMS_BASE + "/api/v1/mngrfile",
                        formDataFile,
                    );
                }

                toast.success("저장되었습니다.");

                // 1. 사이드바(조치내역) 재조회
                if (selectedDetailRow) {
                    fetchSubDetails(selectedDetailRow);
                } else {
                    processNonconformityStore.update((s) => ({
                        ...s,
                        actionDetails: [],
                        actionPhotos: [],
                        defectPhotos: [],
                    }));
                }

                // 2. 메인 리스트(조치여부 등) 서버에서 새로고침하여 즉각 UI 반영
                if ($processNonconformityStore.selectedItem) {
                    import("./store.js").then(
                        ({ fetchProcessNonconformityDetail }) => {
                            fetchProcessNonconformityDetail(
                                $processNonconformityStore.selectedItem,
                            );
                        },
                    );
                }
            }
        } catch (err) {
            console.error("Save error:", err);
            toast.error("저장 중 오류가 발생했습니다.");
        } finally {
            isSaving = false;
        }
    }
</script>

<div class="detail-container">
    {#if isSaving}
        <div class="save-loading-overlay">
            <div class="spinner"></div>
            <span class="loading-text">데이터를 저장하는 중입니다...</span>
        </div>
    {/if}

    <div class="detail-header">
        <button class="back-btn" on:click={goBack}>← 목록으로</button>
        <h2>공정부적합 상세</h2>
        <div class="master-summary">
            <span class="label">LOT:</span>
            <span class="val">
                {$processNonconformityStore.selectedItem?.lot_no}
            </span>
            <span class="label">품목:</span>
            <span class="val">
                {$processNonconformityStore.selectedItem?.item_nm}
            </span>
        </div>
    </div>

    <div class="main-content">
        <!-- LEFT: Detail List -->
        <section class="pane left-pane" class:contracted={isRightPaneVisible}>
            <div class="pane-header">
                <h3>➜ 공정부적합상세</h3>
            </div>
            <div class="table-scroll">
                <table class="mes-table compact">
                    <thead>
                        <tr>
                            <th>불량순번</th>
                            <th>공정명</th>
                            <th>검사항목(구분)</th>
                            <th>검사항목(분류)</th>
                            <th>검사항목</th>
                            <th>검사방법</th>
                            <th>검사기준</th>
                            <th>불량유형</th>
                            <th>불량원인</th>
                            <th>불량내용</th>
                            <th>조치여부</th>
                            <th>비고</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if $processNonconformityStore.details.length === 0}
                            <tr>
                                <td colspan="12" class="no-data">
                                    조회된 상세 내역이 없습니다.
                                </td>
                            </tr>
                        {:else}
                            {#each $processNonconformityStore.details as row}
                                <tr
                                    class:selected={selectedDetailRow?.inspct_sn ===
                                        row.inspct_sn &&
                                        selectedDetailRow?.badn_sn ===
                                            row.badn_sn}
                                    on:click={() => handleDetailRowClick(row)}
                                >
                                    <td>{row.badn_sn}</td>
                                    <td>{row.procs_nm}</td>
                                    <td>{row.inspct_iem_se_code}</td>
                                    <td>{row.inspct_iem_cl_code}</td>
                                    <td class="text-left">{row.inspct_iem}</td>
                                    <td>{row.inspct_mth_code}</td>
                                    <td class="text-left">{row.inspct_stdr}</td>
                                    <td>{row.badn_ty_code}</td>
                                    <td>{row.badn_cause_code}</td>
                                    <td class="text-left">{row.badn_cn}</td>
                                    <td class="center">
                                        <input
                                            type="checkbox"
                                            checked={row.managt_at === "Y"}
                                            disabled
                                        />
                                    </td>
                                    <td class="text-left">{row.rm || ""}</td>
                                </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
        </section>

        <!-- RIGHT: Photos and Actions (Bottom Sliding Sheet) -->
        {#if isRightPaneVisible}
            <div
                class="right-pane"
                transition:slide={{ axis: "y", duration: 400 }}
            >
                {#if isSubDetailLoading}
                    <div class="sub-loading-overlay">
                        <div class="spinner"></div>
                        <span class="loading-text"
                            >데이터를 불러오는 중입니다...</span
                        >
                    </div>
                {/if}

                <!-- Action Details -->
                <section class="pane sub-pane action-pane">
                    <div class="pane-header flex-header">
                        <h3>
                            ➜ 조치내역 ({$processNonconformityStore.actionDetails.length}건)
                        </h3>
                        <div class="header-right-group">
                            <!-- 추가: 조치 여부 수동 스위치 (Segmented Control) -->
                            {#if !isReadOnly}
                                <div class="segmented-control" class:disabled={isReadOnly}>
                                    <button 
                                        type="button" 
                                        class="segment-btn" 
                                        class:active={selectedManagtAt === "N"} 
                                        on:click={() => { if (!isReadOnly) selectedManagtAt = "N"; }}
                                    >
                                        미조치
                                    </button>
                                    <button 
                                        type="button" 
                                        class="segment-btn" 
                                        class:active={selectedManagtAt === "Y"} 
                                        on:click={() => { if (!isReadOnly) selectedManagtAt = "Y"; }}
                                    >
                                        조치완료
                                    </button>
                                    <div class="segment-slider" class:right={selectedManagtAt === "Y"}></div>
                                </div>
                            {/if}

                            {#if !isReadOnly}
                                <div class="btn-group">
                                    {#if selectedDetailRow}
                                        <button
                                            class="m-btn btn-add"
                                            on:click={addActionRow}>추가</button
                                        >
                                        <button
                                            class="m-btn btn-del"
                                            on:click={removeActionRow}>삭제</button
                                        >
                                    {/if}
                                    <button
                                        class="m-btn btn-save"
                                        on:click={handleSave}>저장</button
                                    >
                                </div>
                            {/if}

                            <button class="minimize-btn" on:click={closeSidebar}>
                                상세 접기 ⬇
                            </button>
                        </div>
                    </div>
                    <div class="table-scroll mini">
                         <table class="mes-table mini">
                             <thead>
                                 <tr>
                                     <th width="30px">선택</th>
                                     <th width="80px">조치자사번</th>
                                     <th width="80px">조치자명</th>
                                     <th width="100px">조치시작일시</th>
                                     <th width="100px">조치종료일시</th>
                                     <th>조치내용</th>
                                     <th>비고</th>
                                 </tr>
                             </thead>
                             <tbody>
                                 {#each $processNonconformityStore.actionDetails as action}
                                     <tr>
                                         <td>
                                             <input
                                                 type="checkbox"
                                                 checked={action.delchk === "Y"}
                                                 on:change={(e) =>
                                                     (action.delchk = e.target
                                                         .checked
                                                         ? "Y"
                                                         : "N")}
                                                 disabled={isReadOnly}
                                             />
                                         </td>
                                         <td>{action.maner_empno}</td>
                                         <td>{action.korean_nm || ""}</td>
                                         <td>
                                             <input
                                                 type="date"
                                                 bind:value={action.managt_bgndt}
                                                 class="table-input"
                                                 disabled={isReadOnly}
                                             />
                                         </td>
                                         <td>
                                             <input
                                                 type="date"
                                                 bind:value={action.managt_enddt}
                                                 class="table-input"
                                                 disabled={isReadOnly}
                                             />
                                         </td>
                                         <td class="text-left">
                                             <input
                                                 type="text"
                                                 bind:value={action.managt_cn}
                                                 class="table-input"
                                                 placeholder="내용 입력"
                                                 disabled={isReadOnly}
                                             />
                                         </td>
                                         <td>
                                             <input
                                                 type="text"
                                                 bind:value={action.rm}
                                                 class="table-input"
                                                 placeholder="비고"
                                                 disabled={isReadOnly}
                                             />
                                         </td>
                                     </tr>
                                 {/each}
                                 {#if $processNonconformityStore.actionDetails.length === 0}
                                     <tr>
                                         <td colspan="7" class="no-data-mini">
                                             조치 내역 없음
                                         </td>
                                     </tr>
                                 {/if}
                             </tbody>
                         </table>
                    </div>
                </section>

                {#if selectedDetailRow}
                    <div class="bottom-photos-row">
                        <!-- Left: Defect Photos -->
                        <section class="pane sub-pane photo-pane">
                            <div class="pane-header flex-header">
                                <div class="title-group">
                                    <h3>
                                        ➜ 불량사진 ({$processNonconformityStore.defectPhotos.length}건)
                                    </h3>
                                    {#if selectedDetailRow?.managt_at === "Y"}
                                        <span class="badge success">조치완료</span>
                                    {:else}
                                        <span class="badge warning">미조치</span>
                                    {/if}
                                </div>
                            </div>
                            <div class="table-scroll mini">
                                <table class="mes-table mini">
                                    <thead>
                                        <tr>
                                            <th width="40px">NO</th>
                                            <th width="60px">미리보기</th>
                                            <th>사진명</th>
                                            <th>비고</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each $processNonconformityStore.defectPhotos as photo}
                                            <tr on:click={() => openFile(null, photo)}>
                                                <td>{photo.photo_sn}</td>
                                                <td>
                                                    {#if photo.url}
                                                        <img
                                                            src={photo.url}
                                                            alt="preview"
                                                            style="width: 25px; height: 25px; object-fit: cover; border-radius: 4px;"
                                                        />
                                                    {:else}
                                                        <span style="color:#ccc">N/A</span>
                                                    {/if}
                                                </td>
                                                <td
                                                    class="text-left"
                                                    style="color: #007bff; text-decoration: underline; cursor: pointer;"
                                                >
                                                     {photo.photo_nm ||
                                                         photo.orginlFileNm ||
                                                         "파일정보없음"}
                                                </td>
                                                <td>{photo.rm || ""}</td>
                                            </tr>
                                        {/each}
                                        {#if $processNonconformityStore.defectPhotos.length === 0}
                                            <tr>
                                                <td colspan="4" class="no-data-mini">
                                                    사진 없음
                                                </td>
                                            </tr>
                                        {/if}
                                    </tbody>
                                </table>
                            </div>
                        </section>

                        <!-- Right: Action Photos -->
                        <section class="pane sub-pane action-photo-pane">
                            <div class="pane-header flex-header">
                                <h3>
                                    ➜ 조치사진 ({$processNonconformityStore.actionPhotos.length}건)
                                </h3>
                                {#if !isReadOnly}
                                    <div class="btn-group">
                                        <button
                                            class="m-btn btn-add"
                                            on:click={triggerActionCamera}
                                            >📷 카메라</button
                                        >
                                        <button
                                            class="m-btn btn-add"
                                            on:click={triggerActionGallery}
                                            >🖼️ 갤러리</button
                                        >
                                        <button
                                            class="m-btn btn-del"
                                            on:click={removeActionPhotoRow}
                                            >삭제</button
                                        >
                                    </div>
                                {/if}
                            </div>
                            <div class="table-scroll mini">
                                <table class="mes-table mini">
                                    <thead>
                                        <tr>
                                            <th width="30px">선택</th>
                                            <th width="40px">NO</th>
                                            <th width="60px">미리보기</th>
                                            <th>사진명</th>
                                            <th>비고</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each $processNonconformityStore.actionPhotos as photo, idx}
                                            <tr>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={photo.delchk === "Y"}
                                                        on:change={(e) =>
                                                            (photo.delchk = e.target
                                                                .checked
                                                                ? "Y"
                                                                : "N")}
                                                        disabled={isReadOnly}
                                                    />
                                                </td>
                                                <td>{idx + 1}</td>
                                                <td on:click={() => openFile(photo.file, photo)}>
                                                    {#if photo.url}
                                                        <img
                                                            src={photo.url}
                                                            alt="preview"
                                                            style="width: 25px; height: 25px; object-fit: cover; border-radius: 4px;"
                                                        />
                                                    {:else}
                                                        <span style="color:#ccc">N/A</span>
                                                    {/if}
                                                </td>
                                                <td
                                                    class="text-left"
                                                    style="color: #007bff; text-decoration: underline; cursor: pointer;"
                                                    on:click={() => openFile(photo.file, photo)}
                                                >
                                                    {photo.photo_nm ||
                                                        photo.orginlFileNm ||
                                                        photo.fileNm ||
                                                        photo.name ||
                                                        "파일정보없음"}
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        bind:value={photo.rm}
                                                        class="table-input"
                                                        placeholder="비고 입력"
                                                        disabled={isReadOnly}
                                                    />
                                                </td>
                                            </tr>
                                        {/each}
                                        {#if $processNonconformityStore.actionPhotos.length === 0}
                                            <tr>
                                                <td colspan="5" class="no-data-mini">
                                                    조치 사진 없음
                                                </td>
                                            </tr>
                                        {/if}
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>
                {/if}
            </div>
        {/if}
    </div>
</div>

<input
    type="file"
    bind:this={actionCameraInput}
    style="display:none;"
    on:change={handleActionPhotoChange}
    accept="image/*"
    capture="environment"
/>
<input
    type="file"
    bind:this={actionGalleryInput}
    style="display:none;"
    on:change={handleActionPhotoChange}
    accept="image/*"
    multiple="multiple"
/>

<!-- Image Zoom Modal -->
{#if isImageZoomOpen}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="zoom-overlay" on:click={() => (isImageZoomOpen = false)}>
        <div class="zoom-content" on:click|stopPropagation>
            <img src={zoomedImageUrl} alt="zoom" />
            <button
                class="zoom-close"
                on:click={() => (isImageZoomOpen = false)}>×</button
            >
        </div>
    </div>
{/if}

<!-- Hidden Iframe for Downloads -->
<iframe bind:this={downloadFrame} style="display:none;" title="Download Frame"
></iframe>

<style>
    .detail-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        background: #f1f5f9;
        gap: 10px;
        padding: 10px;
    }
    .detail-header {
        background: white;
        padding: 12px 20px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        gap: 20px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        flex-shrink: 0;
    }
    .back-btn {
        background: #64748b;
        color: white;
        border: none;
        padding: 6px 12px;
        border-radius: 6px;
        font-weight: 700;
        cursor: pointer;
    }
    .detail-header h2 {
        font-size: 1.1rem;
        margin: 0;
        color: #1e293b;
        font-weight: 800;
    }
    .master-summary {
        margin-left: auto;
        display: flex;
        gap: 15px;
        font-size: 0.9rem;
    }
    .master-summary .label {
        color: #64748b;
        font-weight: 700;
    }
    .master-summary .val {
        color: #0f172a;
        font-weight: 800;
    }

    .main-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        overflow: hidden;
        position: relative;
    }
    .pane {
        background: white;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .left-pane {
        height: 100%;
        transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        min-height: 0;
        flex-shrink: 0;
    }
    .left-pane.contracted {
        flex: none;
        height: 185px;
    }

    .right-pane {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        overflow: hidden;
        min-height: 0;
        position: relative;
    }

    .sub-pane {
        flex: 1;
        min-height: 0;
    }

    .bottom-photos-row {
        display: flex;
        flex-direction: row;
        gap: 10px;
        flex: 1;
        min-height: 0;
    }
    .bottom-photos-row .sub-pane {
        flex: 1;
        min-height: 0;
    }

    .pane-header {
        padding: 8px 12px;
        background: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
    }
    .flex-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .title-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .badge {
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 0.7rem;
        font-weight: 800;
    }
    .badge.success {
        background: #dcfce7;
        color: #166534;
    }
    .badge.warning {
        background: #fee2e2;
        color: #991b1b;
    }
    .pane-header h3 {
        font-size: 0.85rem;
        margin: 0;
        font-weight: 800;
        color: #ff5e00;
    }

    .minimize-btn {
        background: #e2e8f0;
        color: #475569;
        border: none;
        padding: 4px 10px;
        border-radius: 4px;
        font-size: 0.75rem;
        font-weight: 800;
        cursor: pointer;
        transition: all 0.2s;
    }
    .minimize-btn:hover {
        background: #cbd5e1;
        color: #1e293b;
    }

    .table-scroll {
        flex: 1;
        overflow: auto;
    }
    .table-scroll.mini {
        max-height: 105px;
    }

    .mes-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.85rem;
    }
    .mes-table.mini {
        font-size: 0.75rem;
    }
    .mes-table.mini th {
        padding: 5px 6px;
        font-size: 0.72rem;
    }
    .mes-table.mini td {
        padding: 4px 6px;
        font-size: 0.75rem;
    }

    .mes-table th {
        background: #f1f5f9;
        padding: 10px 8px;
        color: #475569;
        font-weight: 800;
        position: sticky;
        top: 0;
        z-index: 5;
        border-bottom: 1px solid #e2e8f0;
        white-space: nowrap;
    }
    .mes-table td {
        padding: 8px;
        border-bottom: 1px solid #f1f5f9;
        text-align: center;
        white-space: nowrap;
    }
    .mes-table tr:hover {
        background: #f8fafc;
        cursor: pointer;
    }
    .mes-table tr.selected {
        background: #e0f2fe;
    }

    .text-left {
        text-align: left !important;
        white-space: normal !important;
    }
    .center {
        text-align: center !important;
    }
    .no-data {
        padding: 40px;
        color: #94a3b8;
        font-weight: 600;
        text-align: center;
    }
    .no-data-mini {
        padding: 10px;
        color: #cbd5e1;
        font-size: 0.75rem;
        text-align: center;
    }

    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
    }

    /* Zoom Modal Styles */
    .zoom-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;
        padding: 20px;
    }
    .zoom-content {
        position: relative;
        max-width: 95%;
        max-height: 95%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .zoom-content img {
        max-width: 100%;
        max-height: 90vh;
        object-fit: contain;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
        border-radius: 8px;
    }
    .zoom-close {
        position: absolute;
        top: -40px;
        right: -10px;
        background: none;
        border: none;
        color: white;
        font-size: 40px;
        cursor: pointer;
        line-height: 1;
    }
    .btn-group {
        display: flex;
        gap: 5px;
    }
    .m-btn {
        padding: 4px 10px;
        font-size: 0.7rem;
        font-weight: 800;
        border-radius: 4px;
        border: 1px solid #e2e8f0;
        background: white;
        cursor: pointer;
        transition: all 0.2s;
    }
    .btn-add {
        color: #2563eb;
        border-color: #bfdbfe;
    }
    .btn-del {
        color: #ef4444;
        border-color: #fecaca;
    }
    .btn-save {
        background: #3b82f6;
        color: white;
        border-color: #3b82f6;
    }
    .btn-save:hover {
        background: #2563eb;
    }

    .table-input {
        width: 100%;
        height: 28px;
        border: 1px solid #e2e8f0;
        border-radius: 4px;
        padding: 0 8px;
        font-size: 0.75rem;
        background: #f8fafc;
        outline: none;
    }
    .table-input:focus {
        border-color: #3b82f6;
        background: white;
    }
    .table-input:disabled {
        background: #f1f5f9;
        color: #94a3b8;
        cursor: not-allowed;
    }

    .header-right-group {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    /* Segmented Control Styles */
    .segmented-control {
        position: relative;
        display: flex;
        background: #f1f5f9;
        border-radius: 20px;
        padding: 2px;
        width: 140px;
        height: 32px;
        box-sizing: border-box;
        border: 1px solid #cbd5e1;
        margin: 0;
    }
    .segment-btn {
        position: relative;
        flex: 1;
        background: transparent;
        border: none;
        outline: none;
        font-size: 11px;
        font-weight: 750;
        color: #64748b;
        cursor: pointer;
        z-index: 2;
        transition: color 0.2s ease;
        padding: 0;
        line-height: 26px;
        text-align: center;
    }
    .segment-btn.active {
        color: #ffffff;
    }
    .segmented-control.disabled .segment-btn {
        cursor: not-allowed;
    }
    .segment-slider {
        position: absolute;
        top: 2px;
        left: 2px;
        width: calc(50% - 2px);
        height: calc(100% - 4px);
        background: #ef4444; /* 미조치일 때 빨간색 */
        border-radius: 18px;
        z-index: 1;
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.25s ease;
    }
    .segment-slider.right {
        transform: translateX(100%);
        background: #10b981; /* 조치완료일 때 초록색 */
    }

    /* 신규: 상세 로딩 오버레이 스타일 */
    .sub-loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.85);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 100;
        gap: 12px;
        backdrop-filter: blur(2px);
    }
    .spinner {
        width: 32px;
        height: 32px;
        border: 3.5px solid #f1f5f9;
        border-top: 3.5px solid #ff5e00;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
    .loading-text {
        font-size: 0.8rem;
        font-weight: 800;
        color: #475569;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* 신규: 저장 로딩 오버레이 스타일 */
    .save-loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        gap: 12px;
        backdrop-filter: blur(3px);
        border-radius: 10px;
    }
</style>
